import * as React from "react";
import { graphql, HeadProps, PageProps } from "gatsby";
import Layout from "../modules/layout";
import PageHeader from "../components/pageHeader";
import pageAdaptors from "../adaptors/pageAdaptors/index";
import PageHead from "../components/pageHead";
import RichTextContent from "../modules/richTextContent";

const SimpleRichTextPageTemplate = ({
  data,
}: PageProps<Queries.SimpleRichTextPageTemplateQuery>) => {
  const pageData = pageAdaptors.adaptSimpleRichTextPageTemplate({
    pageData: data.contentfulSimpleRichTextPageTemplate,
    footer: data.contentfulFooter,
    navigationBar: data.contentfulNavigationBar,
  });

  return (
    <Layout
      browserTitle={pageData.browserTitle}
      footer={pageData.footer}
      navigationBar={pageData.navigationBar}
    >
      <PageHeader pageHeader={pageData.header!} />
      <RichTextContent content={pageData.text} />
    </Layout>
  );
};

export const Head = ({
  data,
}: HeadProps<Queries.SimpleRichTextPageTemplateQuery>) => {
  const { browserTitle, title } = data.contentfulSimpleRichTextPageTemplate!;

  return <PageHead browserTitle={browserTitle!} title={title?.title} />;
};

export const query = graphql`
  query SimpleRichTextPageTemplate($id: String!) {
    contentfulNavigationBar(type: { eq: "GlobalNavigationBar" }) {
      primary {
        url
        label
      }
      secondary {
        url
        label
      }
    }
    contentfulFooter(type: { eq: "GlobalFooter" }) {
      links {
        url
        label
      }
    }
    contentfulSimpleRichTextPageTemplate(id: { eq: $id }) {
      browserTitle
      url
      title {
        title
      }
      titleDescription {
        titleDescription
      }
      text {
        raw
      }
    }
  }
`;

export default SimpleRichTextPageTemplate;
